<template>
  <input
    ref="social-media"
    v-model="socialMedia"
    class="field-input__inner form__input"
    :placeholder="placeholder"
    type="text"
    @change="onChangeSocialMedia"
    @keyup.enter="keyupEnter"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
    @input="$emit('input')"
  >
</template>
<script>
export default {
  name: 'InputSocialMedia',
  props: {
    placeholder: {
      type: String,
      default: 'Ссылка на соц.сети',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      socialMedia: '',
    };
  },
  methods: {
    onChangeSocialMedia() {
      this.$emit('input', this.socialMedia);
    },
    keyupEnter() {
      this.$emit('keyup-enter');
    },
  },
};
</script>
